import webservice from './Service/webservice';
import { AesDecrypt, keyPromise } from './Service/crypto';

const api = {
    async fetch(url: string, options: RequestInit = {}) {
        let token = localStorage.getItem("token");
        // console.log(`[api.fetch] URL: ${url}, Token: "${token}"`);

        const headers: any = {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${token}`,
            ...options.headers,
        };
        if (options.body instanceof FormData) {
            delete headers['Content-type'];
        }
        let response = await fetch(webservice + url, {
            ...options,
            headers,
        });
        if (response.status === 401) {
            const refreshToken = localStorage.getItem("refresh_token");

            // Don't attempt refresh if there's no refresh token stored
            if (!refreshToken) {
                return response;
            }

            const resToken = await fetch(webservice + 'api/Authentication/refresh-token', {
                method: 'POST',
                body: JSON.stringify({ refreshToken: refreshToken }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            });

            const resTokenData = await resToken.json();
            const key = await keyPromise;
            const resAccessTokenData = await AesDecrypt(key, resTokenData);

            const newAccessToken = resAccessTokenData?.accessToken;

            // Only update stored token if refresh actually returned a valid token
            if (!newAccessToken) {
                return response;
            }

            localStorage.setItem("token", newAccessToken);

            const newHeaders = {
                ...headers,
                'Authorization': `Bearer ${newAccessToken}`,
            };

            response = await fetch(webservice + url, {
                ...options,
                headers: newHeaders,
            });
        }

        return response;
    },
};

export default api;

